// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_2MCcgk73WMFpsWui6YXbf5kqfZjL" as const;
export const builtAt = "2026-11-03T21:43:54.742Z" as const;
export const vercelEnv: string | null = "production";
export const gitCommitSha: string | null = "d6356ba177070ce84b06d9b0a3b4c81e49939b22";
export const deploymentId: string | null = "dpl_2MCcgk73WMFpsWui6YXbf5kqfZjL";
